import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const ItrGetProfileInputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-user', title: 'ITR Get Profile', subtitle: 'Fetch ITR profile details for a client' }}
        fields={[
            { name: 'client_id', label: 'Client ID', icon: 'pi-key', placeholder: 'itr_xxxxxxxxxxxxx', maxLength: 100, mono: true,
              colClass: 'col-12 md:col-8 lg:col-6' },
        ]}
        endpoint={{
            path: '/surepass/itr/get-profile',
            bodyMapper: (v, sid) => ({ client_id: v.client_id.trim(), api_provider_service_id: parseInt(sid, 10) }),
        }}
        consentReportType="itr-get-profile"
        submitLabel="Fetch Profile"
        successSummary="ITR profile fetched"
        errorSummary="Profile fetch failed"
        confirmHeader="Confirm profile fetch"
        confirmAcceptLabel="Yes, fetch"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'ITR Profile', icon: 'pi-user' }}
    />
);

export default ItrGetProfileInputComponent;
